import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=0bc8dc72&scoped=true"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=0bc8dc72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8dc72",
  null
  
)

export default component.exports